import alt from '../alt';
import Immutable from 'seamless-immutable';
import {datasource} from 'alt-utils/lib/decorators';
import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils/index';
import root from 'window-or-global';
import AppConfigActions from '../actions/AppConfigActions';
import AppConfigSource from '../sources/AppConfigSource';

const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT',
    'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];

@datasource(AppConfigSource)
@seamlessImmutable
class AppConfigStore {
    getStateFunctions() {
        return {
            getDownloadUrl() {
                if (root._epicGamesNav && root._epicGamesNav.browser && root._epicGamesNav.browser.mac) {
                    return this.macDownloadUrl;
                }
                return this.pcDownloadUrl;
            },
            isEu() {
                return euCountries.indexOf(this.country) >= 0;
            },
            checkGameLaunched() {
                let match = false;
                const crtCountry = this.country;
                const launchedCountries = this.launchedCountries.asMutable({deep: true});
                const launcherCountriesInfo = launchedCountries.countryLaunchedInfo;

                if (launcherCountriesInfo) {
                    for (const country of launcherCountriesInfo) {
                        if (crtCountry === country.countryCode) {
                            match = true;
                        }
                    }
                }
                return match;
            },
            checkGameUnavailable() {
                let match = false;
                const crtCountry = this.country;
                const {unavailableCountries} = this;

                if (unavailableCountries.countryCode) {
                    for (const country of unavailableCountries.countryCode) {
                        if (crtCountry === country) {
                            match = true;
                        }
                    }
                }
                return match;
            }
        };
    }

    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        const initialState = Immutable({
            pcDownloadUrl: null,
            macDownloadUrl: null,
            motdSlug: null,
            isPrerender: false,
            androidDownloadUrl: null,
            euCookieMessage: {},
            country: '',
            globalAlert: null,
            launchedCountries: {},
            unavailableCountries: {},
            epicSid: null
        });
        this.state = initialState.merge(this.getStateFunctions());
        this.bindActions(AppConfigActions);
    }

    onFetchEpicSid() {
        if (this.state.epicSid) return;
        this.getInstance().fetchEpicSid();
        return this.setState(this.state.set('loading', true));
    }

    onFetchEpicSidSuccess({data = {}}) {
        this.setState(this.state.merge(
            {
                epicSid: data.result,
                loading: false
            }));
    }

    onFetchEpicSidFailure(response) {
        console.error('Failed to send 404 not found message.');
        this.setState(this.state.merge({loading: false}));
    }
}

export default alt.createStore(AppConfigStore, 'AppConfigStore');
